import { useState, useCallback, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import {
    Box,
    Container,
    Typography,
    Toolbar,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Avatar,
} from "@mui/material";

const HistoryItemPage = () => {
    const { sessionId } = useParams();

    const backendEndpoint = process.env.REACT_APP_BACKEND_ENDPOINT;

    const [messages, setMessages] = useState([]);

    const escapeHtml = (text) => {
        return text
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    };

    const linkify = (inputText) => {
        // From:https://stackoverflow.com/questions/49634850/convert-plain-text-links-to-clickable-links

        var replacedText, replacePattern1, replacePattern2, replacePattern3;

        //URLs starting with http://, https://, or ftp://
        replacePattern1 =
            /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
        replacedText = inputText.replace(
            replacePattern1,
            '<a href="$1" target="_blank">$1</a>',
        );

        //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replace(
            replacePattern2,
            '$1<a href="http://$2" target="_blank">$2</a>',
        );

        //Change email addresses to mailto:: links.
        replacePattern3 =
            /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = replacedText.replace(
            replacePattern3,
            '<a href="mailto:$1">$1</a>',
        );

        return replacedText;
    };

    const getCookieValue = useCallback(
        (name) =>
            document.cookie
                .match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")
                ?.pop() || "",
        [],
    );

    const loadMessages = useCallback(async () => {
        const response = await fetch(
            `${backendEndpoint}/chat_history/${sessionId}/`,
            {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": getCookieValue("csrfToken"),
                },
            },
        );

        const json = await response.json();
        const messages = json.messages;

        setMessages(
            messages.map((message) => ({
                ...message,
                text: message.text,
            })),
        );
    }, [backendEndpoint, sessionId, getCookieValue]);

    useEffect(() => {
        loadMessages();
    }, [loadMessages]);

    return (
        <Box sx={{ width: "100%" }}>
            <Toolbar sx={{ padding: "0 !important" }}>
                <Link
                    to="/history"
                    style={{
                        textDecoration: "none",
                        color: "inherit",
                        borderRadius: 100,
                    }}
                >
                    <IconButton title="voltar" edge="end" aria-label="edit">
                        <ArrowBack />
                    </IconButton>
                </Link>
            </Toolbar>
            <Typography variant="h4" gutterBottom>
                Histórico de conversas - {sessionId}
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    borderColor: "#eeeeee",
                    border: "1px solid #dedede",
                    borderRadius: 2,
                    height: 600,
                    overflowY: "auto",
                    mt: 4,
                }}
            >
                <Container maxWidth="md">
                    <List
                        sx={{ flexGrow: 1, overflowY: "auto", marginBottom: 2 }}
                    >
                        {messages.map((message, index) => (
                            <ListItem
                                key={index}
                                sx={{
                                    display: "flex",
                                    flexDirection:
                                        message.sender === "bot"
                                            ? "row"
                                            : "row-reverse",
                                    textAlign:
                                        message.sender === "bot"
                                            ? "left"
                                            : "right",
                                    whiteSpace: "pre-line",
                                    mt: 2,
                                    backgroundColor: "#f5f5f5",
                                }}
                            >
                                <Avatar
                                    sx={{
                                        backgroundColor: "#eeeeee",
                                        border: "1px solid #dedede",
                                    }}
                                >
                                    {message.sender === "bot" ? "🤖" : "👤"}
                                </Avatar>
                                <ListItemText
                                    sx={{ marginRight: 2, marginLeft: 2 }}
                                    primary={
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: linkify(
                                                    escapeHtml(message.text),
                                                ),
                                            }}
                                        />
                                    }
                                    secondary={
                                        message.sender === "bot"
                                            ? `Assistente - ${message.dateTime}`
                                            : `Usuário - ${message.dateTime}`
                                    }
                                />
                            </ListItem>
                        ))}
                    </List>
                </Container>
            </Box>
        </Box>
    );
};

export default HistoryItemPage;
